var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M63.764,30.844,54.844,27.5V1.9a1.9,1.9,0,0,0-1.9-1.9H9.775a1.9,1.9,0,0,0-1.9,1.9V7.617H1.9A1.9,1.9,0,0,0,0,9.521V63.1A1.9,1.9,0,0,0,1.9,65H45.068a1.9,1.9,0,0,0,1.9-1.9V57.383H49.8a17.664,17.664,0,0,0,2.466,1.148,1.9,1.9,0,0,0,1.337,0A17.557,17.557,0,0,0,65,42.093V32.627A1.9,1.9,0,0,0,63.764,30.844Zm-20.6,30.348H3.809V11.426H7.871V55.479a1.9,1.9,0,0,0,1.9,1.9H43.164ZM11.68,53.574V3.809H51.035V27.5l-8.6,3.224H32.627a1.9,1.9,0,0,0,0,3.809h8.252V38.34H32.627a1.9,1.9,0,0,0,0,3.809H40.88a17.6,17.6,0,0,0,.428,3.809H32.627a1.9,1.9,0,0,0,0,3.809H42.643a17.6,17.6,0,0,0,2.512,3.809ZM61.191,42.093a13.817,13.817,0,0,1-8.252,12.6,13.817,13.817,0,0,1-8.252-12.6V33.947l8.252-3.094,8.252,3.094Z",
    fill: "#2e3d62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/T1.f66d1d1d910246e059f86e371ee253d1.svg";
export { ForwardRef as ReactComponent };